// src/features/locations/LocationsGrid.jsx
//
// Slice U4 — Tiles view for the Portfolio page. Renders a responsive
// grid of LocationTile cards. Mirrors the LocationList / LocationsMap
// API: PortfolioView passes the already-filtered + ranked `locations`
// array, plus loading/error/emptyState slots.
//
// Layout follows the legacy LocationCardGrid (line 7650 of the
// monolith): CSS grid, `repeat(auto-fill, minmax(280px, 1fr))`, 16px
// gap. At the 1200px portfolio container width that yields 4 columns
// with comfortable margins; at tablet widths it gracefully degrades
// to 2-3 columns. The `auto-fill` (rather than `auto-fit`) is
// deliberate — auto-fit stretches a single orphan tile across the
// entire row, which looks broken; auto-fill leaves the orphan at its
// natural width.

import React from "react";
import { LocationTile } from "./LocationTile.jsx";
import { ErrorBanner } from "../../components/ErrorBanner.jsx";
import { T } from "../../app/tokens.js";
import { S } from "../../app/styles.js";

export function LocationsGrid({
  locations,
  onSelect,
  selectedId = null,
  loading,
  error,
  emptyState,
}) {
  const list = locations || [];

  return (
    <div data-testid="locations-grid-shell">
      <ErrorBanner error={error} />

      {loading && (
        <div data-testid="locations-grid-loading" style={{ ...S.emptyState, fontSize: T.fsBase }}>
          Loading…
        </div>
      )}

      {!loading && !error && list.length === 0 && (
        emptyState ?? (
          <div style={{ ...S.emptyState, color: T.light, fontSize: T.fsBase }}>
            No locations yet.
          </div>
        )
      )}

      {!loading && !error && list.length > 0 && (
        <div
          data-testid="locations-grid"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
            gap: 16,
          }}
        >
          {list.map((loc) => (
            <LocationTile
              key={loc.id}
              location={loc}
              selected={selectedId === loc.id}
              onClick={() => onSelect && onSelect(loc.id)}
            />
          ))}
        </div>
      )}
    </div>
  );
}
